/**
 * Lazy loader for using forms rendered by @doodl/react-forms, which only loads &
 * initialises React when a form is actually encountered on a page.  Ideally, we
 * do this only when a form becomes visible in the user's viewport, using
 * Intersection Observer if supported.
 */

// Use the lazy-loaded form builder
const lazyForm = (cb) =>
    import(/* webpackChunkName: "ddl-react-form" */ "./react-form").then(
        ({ default: initForm }) => cb(initForm)
    );

/**
 * If the current browser supports Intersection Observer, lazy load
 * forms once they become visible.  Otherwise initialise them straight away
 */
export default () => {
    const formElements = document.querySelectorAll("[data-schema-id]");
    if (formElements.length) {
        if ("IntersectionObserver" in window) {
            const io = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const node = entry.target;
                        lazyForm((initForm) => initForm(node));
                        // We only want this to fire once, so unobserve once we get here
                        observer.unobserve(node);
                    }
                });
            });

            formElements.forEach((element) => io.observe(element));
        } else {
            lazyForm((initForm) => {
                formElements.forEach((formRoot) => initForm(formRoot));
            });
        }
    }
};